import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { StateProvidor } from './StateProvidor';
import reducer, { initialState } from './reducer';

ReactDOM.render(
	<React.StrictMode>
		<StateProvidor initialState={initialState} reducer={reducer}>
			<App />
		</StateProvidor>
	</React.StrictMode>,
	document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
